import "../stylesheets/LandingPage.css";

const LandingPage = () => {
     
  return (
    <section>
      <div className="landingpage" id="home">
        <div className="homePageTitleContainer">
          <h1>Not So <span className="socialPlanner">Social Planner</span></h1>
          <h2>An App for the <span className="socialIntrovert">Social Introvert</span> in All of Us</h2>
        </div>
      </div>
    </section>
  );
};

export default LandingPage;
